import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-file-text-line",
    title: "资料整理",
    desc: "每部影片都包含主创、年份、类型与时长等基础信息，方便快速核对。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "剧情解析",
    desc: "从叙事结构、镜头语言到人物动机，用编辑视角拆解作品的可看之处。",
  },
  {
    icon: "ri-chat-quote-line",
    title: "观点汇集",
    desc: "收录读者短评摘要，呈现不同视角的观看体验，评论目前仅作展示。",
  },
];

export default function AboutStrip() {
  return (
    <section className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2">
            <span className="h-3 w-[3px] rounded-full bg-accent-500"></span>
            <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">
              About the archive
            </span>
          </div>
          <h2 className="mt-2 text-balance font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
            一个只做资料与解析的
            <br className="hidden md:block" />
            影视内容站点
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            我们不做播放，也不做下载。所有页面围绕「看懂一部片子」展开：先给基本信息，再给剧情与创作视角，最后是观众的讨论。
          </p>
          <Link
            to="/about"
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            了解本站定位
            <i className="ri-arrow-right-up-line text-sm"></i>
          </Link>
        </div>

        <div className="lg:col-span-8">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200/80 bg-background-100/60 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-200 text-accent-400">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="mt-4 font-heading text-sm font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-6 text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-4 flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-100/40 p-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-3">
              <i className="ri-error-warning-line mt-0.5 text-lg text-primary-400"></i>
              <p className="text-xs leading-6 text-foreground-500">
                本站为影视资料演示站点，内容面向成年观众，不提供任何影视资源的播放与下载入口。
              </p>
            </div>
            <Link
              to="/search"
              className="shrink-0 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              开始检索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}